import {BlockMath, InlineMath} from "react-katex";

const CostFunctionIntro = () => {
    return (
        <div className="max-w-4xl mx-auto px-4">

        <h1 className="tw-header font-bold text-gray-900 mb-4">Cost Functions</h1>
            <p className="text-gray-600 tw-subtitle text-justify">
                Cost functions are like the ultimate judge in a machine learning competition - they tell you
                exactly how wrong your model is being. They measure the
                difference between what your model predicts and what actually happens in the real world. However the
                cost function is far from being our only indicator of an accurate and reliable model, in fact, many make
                the mistake of only relying on it, leading to overfitting, but that's a discussion for another section.
            </p>
            <hr className="mt-2 mb-2"/>
            <p className="tw-subtitle text-gray-600">
                The most popular cost function is Mean Squared Error (MSE), which basically says "let's square
                all the errors so negative and positive mistakes don't cancel each other out":
            </p>
            <BlockMath math="MSE = \frac{1}{n}\sum_{i=1}^{n}(y_i - \hat{y_i})^2"/>
            <p className="tw-subtitle text-gray-600">
                For classification problems, we often use Cross-Entropy Loss, which gets really upset when
                your model is confidently wrong:
            </p>
            <BlockMath math="CE = -\sum_{i=1}^{n} y_i \log(\hat{y_i})"/>
            <p className="tw-subtitle text-gray-600">
                Where <InlineMath math="y_i"/> is the actual value and <InlineMath math="\hat{y_i}"/> is
                the predicted value. The goal is always to minimize this function - basically, we want to
                make our mathematical judge as happy as possible. It's like playing a video game where
                your score is how wrong you are, and you're trying to get the lowest score possible!
            </p>
        </div>
    )
}

export default CostFunctionIntro;